// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import Raven from 'raven-js';
import RavenVue from 'raven-js/plugins/vue';
import moment from 'moment';
import * as VeeValidate from 'vee-validate';
import VueSweetalert2 from 'vue-sweetalert2';
import Paginate from 'vuejs-paginate';
import router from './router/index-client';
import store from './store';
import App from './AppClients.vue';

Vue.component('paginate', Paginate);

Vue.use(VueSweetalert2);
// VeeValidate.Validator.localize('ru', ru);

Vue.use(VeeValidate, {
  locale: 'ru',
});
Vue.config.productionTip = false;

Vue.filter('dateFilter', (date, formatMask) => {
  moment.locale('ru');
  return date ? moment.parseZone(date).format(formatMask) : null;
});

Vue.filter('countGuest', (guests) => {
  let children = 0;
  let adult = 0;
  guests.forEach((guest) => {
    if (!guest.age_qualifier) {
      adult = guest.persons;
    } else {
      children += guest.persons;
    }
  });
  let result = `${adult} взр.`;
  if (children > 0) {
    result += ` + ${children} дет.`;
  }
  return result;
});

if (process.env.RAVEN_CONFIG) {
  Raven
    .config(process.env.RAVEN_CONFIG)
    .addPlugin(RavenVue, Vue)
    .install();
}

/* eslint-disable no-new */
new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
